import { Component, Input, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
    selector: 'app-select-check-all',
    templateUrl: './select-check-all.component.html',
    styleUrls: ['./select-check-all.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SelectCheckAllComponent {
  @Input() model: UntypedFormControl;
  @Input() values: any[] = [];
  @Input() idField: string | number;
  @Input() text = '--ALL--';

  isChecked(): boolean {
    return (
      this.model.value &&
      this.values?.length &&
      this.model.value?.length === this.values?.length
    );
  }

  isIndeterminate(): boolean {
    return (
      this.model.value &&
      this.values?.length &&
      this.model.value?.length > 0 &&
      this.model.value?.length < this.values?.length
    );
  }

  toggleSelection(change: MatCheckboxChange): void {
    if (change.checked) {
      if (this.idField) {
        this.model.setValue(this.values.map((value) => value[this.idField]));
      } else {
        this.model.setValue(this.values);
      }
    } else {
      this.model.setValue([]);
    }
    this.model.markAsDirty();
  }
}
